"use strict";

exports.__esModule = true;
exports.useIntlNavigation = exports.default = void 0;
var _react = require("react");
var IntlNavigationContext = /*#__PURE__*/(0, _react.createContext)({
  defaultLocale: ''
});
var IntlNavigationProvider = IntlNavigationContext.Provider;
var useIntlNavigation = exports.useIntlNavigation = function useIntlNavigation() {
  var context = (0, _react.useContext)(IntlNavigationContext);
  return context;
};
var _default = exports.default = IntlNavigationProvider;